<template>
    <div class="features-area pt-100 pb-75">
        <div class="container">
            <div class="section-title">
                <span class="sub-title green-color">Key Features</span>
                <h2 class="nunito-font">Most probably included best features ever</h2>
            </div>
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200">
                    <div class="features-box">
                        <div class="icon">
                            <i class="flaticon-nature"></i>
                        </div>
                        <h3 class="nunito-font">Nature All Around You</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est non feugiat sagittis, donec.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="100">
                    <div class="features-box">
                        <div class="icon">
                            <i class="flaticon-parking"></i>
                        </div>
                        <h3 class="nunito-font">Get Free Parking Place</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est non feugiat sagittis, donec.</p>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-6" data-aos="fade-up" data-aos-duration="1200" data-aos-delay="200">
                    <div class="features-box">
                        <div class="icon">
                            <i class="flaticon-shield"></i>
                        </div>
                        <h3 class="nunito-font">24/7 Security</h3>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed est non feugiat sagittis, donec.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Features'
}
</script>